/**
 * Append a cache-bust token to a ledger / cash-statement export URL.
 *
 * The export endpoints render a PNG/PDF fresh from the live DB, but the URL is
 * identical across edits (same party + from/to), so a previously-fetched copy
 * can be served from the browser disk cache or an edge proxy (Cloudflare caches
 * .png/.pdf by extension) — showing OLD transactions after a change. The
 * backend now sends `Cache-Control: no-store`; this token is belt-and-suspenders
 * for any aggressive edge rule that ignores it. Computed at build/click time so
 * each download is a distinct URL.
 */
export function withCacheBust(url: string): string {
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}cb=${Date.now()}`;
}
